import { makeRequest, CommonRequestOptions } from '../../makeRequest';

export const ACCOUNT_TYPES = ['null', '1', '3', '7', '8', '10'] as const;

export type AccountType = (typeof ACCOUNT_TYPES)[number];

// For the accountType field
// 'null' = user, '1' = admin, '3' = moderator, '7' = 'author, '8' = author & mod, '10' = contributor
export type CreateUsersByEmailOptions = CommonRequestOptions & {
   emails: string[];
   accountType: AccountType;
};

export function createUsersByEmail({ emails, accountType, ...common }: CreateUsersByEmailOptions) {
   return makeRequest('post', 'users/createByEmails', {
      body: {
         emails: emails,
         accountType: accountType,
      },
      ...common,
   });
}
